export { isAdult } from './age';
export { onlyNumberValidation } from './number';
export { getPhoneValidator, plPhoneValidation } from './phone';
